export default{
    CREATE_COURSE(state, payload){
        state.createcourse = payload;
    },
    GET_TOPIC_BY_CHAPTERID(state, payload){
        state.TopicByID = payload;
    },
    GET_SINGLE_COURSE(state, payload){
        state.courseDetails = payload;
    },
}